import { UHCrudSchemaObjectBaseClass } from '@frontend/unhideschool/core/models/base-uh-crude.model';

export interface AddSubscriptionMemberSchemaModel {
    uid: number;
    subscriptionid: number;
    subscriptionmemberstateid: number;
    subscriptionmembertypeid: number;
}

export class AddSubscriptionMemberSchema extends UHCrudSchemaObjectBaseClass {
    uid: number;
    subscriptionid: number;
    subscriptionmemberstateid: number;
    subscriptionmembertypeid: number;

    constructor(uid: number, subscriptionid: number, subscriptionmemberstateid: number, subscriptionmembertypeid: number) {
        super();
        this.uid = uid;
        this.subscriptionid = subscriptionid;
        this.subscriptionmemberstateid = subscriptionmemberstateid;
        this.subscriptionmembertypeid = subscriptionmembertypeid;
    }
}
